import React, { SyntheticEvent } from 'react';
import AudioControl from '../../../common/components/AudioControl';
import AudioControlPlayButton from '../../../common/components/AudioControlPlayButton';
import AudioControlSeekbar from '../../../common/components/AudioControlSeekbar';
import { MusicAlbumTrackEntity } from '../../types/MusicAlbumEntityTypes';
import { MusicEntity } from '../../types/MusicEntityTypes';

/**
 * トラックを上に移動するボタン
 */
function MusicAlbumEditForm2ListItemMoveUpButton({
  disabled,
  onClick,
} : {
  disabled: boolean,
  onClick: () => void,
}) {
  const cancelEvent = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };
  return (
    <>
      { /* eslint-disable-next-line jsx-a11y/anchor-is-valid */ }
      <a>
        { /* eslint-disable-next-line max-len */ }
        { /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */ }
        <img
          src="/img/music/up_bt.svg"
          alt="上"
          style={disabled ? { opacity: 0.1, pointerEvents: 'none' } : {}}
          // eslint-disable-next-line max-len
          onClick={(e) => { cancelEvent(e); if (!disabled) { onClick(); } }}
        />
      </a>
    </>
  );
}

/**
 * トラックを下に移動するボタン
 */
function MusicAlbumEditForm2ListItemMoveDownButton({
  disabled,
  onClick,
} : {
  disabled: boolean,
  onClick: () => void,
}) {
  const cancelEvent = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };
  return (
    <>
      { /* eslint-disable-next-line jsx-a11y/anchor-is-valid */ }
      <a>
        { /* eslint-disable-next-line max-len */ }
        { /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */ }
        <img
          src="/img/music/down_bt.svg"
          alt="下"
          style={disabled ? { opacity: 0.1, pointerEvents: 'none' } : {}}
          // eslint-disable-next-line max-len
          onClick={(e) => { cancelEvent(e); if (!disabled) { onClick(); } }}
        />
      </a>
    </>
  );
}

/**
 * トラックを削除するボタン
 */
function MusicAlbumEditForm2ListItemDeleteButton({
  onClick,
} : {
  onClick: () => void,
}) {
  const cancelEvent = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };
  return (
    <>
      { /* eslint-disable-next-line jsx-a11y/control-has-associated-label */ }
      <a href="/" className="bt_cancel" onClick={(e) => { cancelEvent(e); onClick(); }}>
        <img src="/img/music/bt_cancel_m.svg" alt="" />
      </a>
    </>
  );
}

/**
 * トラックビュー
 */
export default function MusicAlbumEditForm2ListItemView({
  musicAlbumTrack,
  isLastTrack,
  onMoveNext,
  onMovePrev,
  onDelete,
} : {
  musicAlbumTrack: MusicAlbumTrackEntity & {
    music: MusicEntity,
  },
  isLastTrack: boolean,
  onMoveNext: () => void,
  onMovePrev: () => void,
  onDelete: () => void,
}) {
  const [fadeOutUp, setFadeOutUp] = React.useState(false);
  const [fadeOutDown, setFadeOutDown] = React.useState(false);
  const songOne = React.useRef(null);

  React.useEffect(() => {
    if (songOne.current === null) return;
    if (fadeOutUp) {
      $(songOne.current).addClass('song_fadeOutUp');
      setFadeOutUp(false);
    } else if ($(songOne.current).hasClass('song_fadeOutUp')) {
      $(songOne.current).removeClass('song_fadeOutUp');
    }
  }, [fadeOutUp]);

  React.useEffect(() => {
    if (songOne.current === null) return;
    if (fadeOutDown) {
      $(songOne.current).addClass('song_fadeOutDown');
      setFadeOutDown(false);
    } else if ($(songOne.current).hasClass('song_fadeOutDown')) {
      $(songOne.current).removeClass('song_fadeOutDown');
    }
  }, [fadeOutDown]);

  return (
    <div className="song_one" ref={songOne}>
      <div className="inner">
        <AudioControl url={musicAlbumTrack.music.source_audio_url}>
          <AudioControlPlayButton />
          <div className="song_info">
            <p className="song_title">
              <span className="ttl">{`${musicAlbumTrack.track_no}. ${musicAlbumTrack.music.title}`}</span>
              {musicAlbumTrack.music.version}
            </p>
            <AudioControlSeekbar />
          </div>
        </AudioControl>
        <div className="right_bt_area">
          <div className="move_bt">
            <MusicAlbumEditForm2ListItemMoveUpButton
              disabled={musicAlbumTrack.track_no === 1}
              onClick={() => { onMovePrev(); setFadeOutUp(true); }}
            />
            <MusicAlbumEditForm2ListItemMoveDownButton
              disabled={isLastTrack}
              onClick={() => { onMoveNext(); setFadeOutDown(true); }}
            />
          </div>
        </div>
      </div>
      <MusicAlbumEditForm2ListItemDeleteButton onClick={() => { onDelete(); }} />
    </div>
  );
}
